import HangerBlackIcon from '../../assets/svg/hanger_tip_white.svg';
import { StyleQuizRedirectionSource } from 'containers/chat';
import { useChatContext } from 'containers/chat/hooks/ChatContext';
import utils from 'utils/utils';
import config from 'config';
import themes from 'constants/themes';
import { ETitleModal } from 'component/modal_full_screen';

interface ConversationFooterProps {
    handleRedirectToStyleQuiz: (value: string) => void;
    handleFooterClick: (name: string, code: string) => void;
}

export default function ConversationFooter({ handleRedirectToStyleQuiz, handleFooterClick }: ConversationFooterProps) {
    const { isUserAuthenticated } = useChatContext();
    return (
        <>
            <div className="footer-container">
                <span
                    onClick={() => {
                        handleRedirectToStyleQuiz(StyleQuizRedirectionSource.COMPLETE_QUIZ_HANGER_BUTTON);
                    }}
                    className="login-button style-preference-button"
                >
                    <img
                        src={HangerBlackIcon}
                        alt="Taffi"
                        height={24}
                        width={24}
                        className="style-quiz-icon-image img-cover"
                    />
                    {''}
                    <span className="login-button-text style-preference-button-text">Style Preferences</span>
                </span>
                <div className="caption-text m-10" style={{ display: isUserAuthenticated ? 'none' : 'block' }}>
                    <div className="flex-row">
                        <div className="flex1 text-right mr-10">
                            {utils.getAnchorNewTab(config.privacyPolicy.url, config.privacyPolicy.text, {
                                color: themes.palette.primary.main,
                                textDecoration: 'none',
                            })}
                        </div>
                        <div className="flex1 ml-10">
                            {utils.getAnchorNewTab(config.termsOfService.url, config.termsOfService.text, {
                                color: themes.palette.primary.main,
                                textDecoration: 'none',
                            })}
                        </div>
                    </div>
                    <div className="flex-row mt-10">
                        <div
                            className="flex1 text-right mr-10 cursor-pointer"
                            onClick={() => handleFooterClick('Contact Us', ETitleModal.CONTACT_US)}
                        >
                            Contact Us
                        </div>
                        <div
                            className="flex1 ml-10 cursor-pointer"
                            onClick={() => handleFooterClick('App Version', ETitleModal.APP_VERSION)}
                        >
                            App Version
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
